import { combineReducers } from '@reduxjs/toolkit';
import dashboardSlice from './dashboardSlice';
import userDefinedWidgetsSlice from './userDefinedWidgetsSlice';

const dashboardReducer = combineReducers({
  default: dashboardSlice,
  userDefinedWidgets: userDefinedWidgetsSlice,
});

export default dashboardReducer;
